import { CommonStrictFetch } from "../common/base.js";
import { mergeOptions } from "../common/utils.js";
import { useNuxtApp, useRuntimeConfig } from "#imports";
class ClientStrictFetch extends CommonStrictFetch {
  get config() {
    return this.app.$strictFetch;
  }
  get app() {
    return useNuxtApp();
  }
  get additionalHeaders() {
    const config = useRuntimeConfig();
    const cookies = this.app.ssrContext?.event.headers?.get("cookie");
    const baseOptions = mergeOptions(config.public.strictFetchOptions, this.config.options);
    return baseOptions.proxyServerCookies && cookies ? { Cookie: cookies } : {};
  }
  autoInit = () => {
    this.app.provide("strictFetch", {
      options: {},
      orderRequests: {},
      orderHooks: {},
      methodSignals: {}
    });
  };
}
export const StrictFetch = new ClientStrictFetch();
